import {ChangeDetectorRef, Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {AuthService, StorageService} from '@cosbeni/auth';
import * as wjcCore from '@mescius/wijmo';
import {GapiSession} from '../gapi/gapi.session';
import {LoadUserAction} from '../ngrx/actions/user.action';
import {Capability, canWith, CAPS} from '../services/roles';

/**
 * kobe-ac 業務画面のコンテナ (旧 kobe-ac.app の nav / MainCtrl 相当)。
 * active-promotion.app の admin-container と同じシェル構造でサイドナビだけ差し替える。
 */
@Component({
    standalone: false,
    selector: 'app-kobeac-container',
    templateUrl: './kobeac-container.component.html',
})
export class KobeacContainerComponent {
    user: any;
    // テンプレートからケーパビリティ定数を参照するため公開する。
    readonly CAPS = CAPS;
    private database: string;

    constructor(private store: Store<any>, private auth: AuthService, private storage: StorageService,
                private gapiSession: GapiSession, private cdRef: ChangeDetectorRef) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((feature: any) => {
            if (wjcCore.isObject(feature.user) && feature.user.loaded) {
                this.user = feature.user.user;
            }
        });
        this.database = this.storage.get('database');
    }

    logout(): void {
        this.auth.logout().subscribe(() => {
        });
        this.storage.remove(this.database + '_url');
    }

    /** roles.ts のケーパビリティでメニュー可視性を判定する。 */
    can(capability: Capability | Capability[]): boolean {
        return canWith(wjcCore.isObject(this.user) ? this.user.roles : null, capability);
    }
}
